import { render, staticRenderFns } from "./InitialForm.vue?vue&type=template&id=24cdb8ec&scoped=true&"
import script from "./InitialForm.vue?vue&type=script&lang=js&"
export * from "./InitialForm.vue?vue&type=script&lang=js&"
import style0 from "./InitialForm.vue?vue&type=style&index=0&id=24cdb8ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24cdb8ec",
  null
  
)

export default component.exports